"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var Forms = _interopRequireWildcard(require("./"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const DataArray = props => {
  // if (!props.fetched) return <Spinner />

  return /*#__PURE__*/_react.default.createElement("div", null, props.schema.array.map(field => {
    const Component = Forms[field.type];
    return /*#__PURE__*/_react.default.createElement("div", {
      key: field.key,
      className: 'form-group row'
    }, /*#__PURE__*/_react.default.createElement("label", {
      className: "col-sm-2 text-muted text-uppercase"
    }, /*#__PURE__*/_react.default.createElement("small", null, field.displayName)), /*#__PURE__*/_react.default.createElement("div", {
      className: "col-sm-10"
    }, /*#__PURE__*/_react.default.createElement(Component, {
      fetched: props.fetched,
      fetching: props.fecthing,
      value: props.value && props.value[field.key]
    })));
  }));
};
var _default = exports.default = DataArray;
module.exports = exports.default;